import React from 'react';
import './ContactCTA.css';

function ContactCTA({ title, subtitle }) {
  const openChatBot = () => {
    const event = new CustomEvent('openChatBot');
    window.dispatchEvent(event);
  };

  return (
    <section className="contact-cta">
      <div className="container">
        <div className="cta-content fade-in">
          <h2>{title || 'Garden Poète에 문의하기'}</h2>
          {subtitle && <p className="cta-subtitle">{subtitle}</p>}
          <p>
            궁금하신 점을 편하게 물어보세요.<br />
            예약, 견적, 웨딩 관련 무엇이든 상담해 드립니다.
          </p>
          <button
            className="btn-kakao"
            onClick={openChatBot}
          >
            상담하기
          </button>
        </div>
      </div>
    </section>
  );
}

export default ContactCTA;
